import { render, staticRenderFns } from "./ProjectBuyersDataTable.vue?vue&type=template&id=097b048d&scoped=true&"
import script from "./ProjectBuyersDataTable.vue?vue&type=script&lang=ts&"
export * from "./ProjectBuyersDataTable.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectBuyersDataTable.vue?vue&type=style&index=0&id=097b048d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097b048d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCheckbox,VChip,VIcon})
